<script setup lang="ts">
import { onMounted, onBeforeUnmount, toRefs,watch,reactive, ref, nextTick } from "vue";
import { uuid } from 'vue-uuid';
import { getLargestZIndex } from "../plugins/utility";

const props = defineProps({
    isVisible: {
      required: true,
      type: Boolean,
      default: false,
    },
    isLoading: {
      type:Boolean,
      default : () => {
        return false;
      }
    },
    cancelButtonName: {
      type:String,
      default : () => {
        return 'キャンセル';
      }
    },
    submitButtonName: {
      type:String,
      default : () => {
        return '';
      }
    },
    close: {
      type:Function,
    },
    submit: {
      type:Function,
    },
})

const element = ref();
const bodyElement = ref();
const zIndex = ref(10);
const topPosition = ref(5);
const { isVisible } = toRefs(props);
watch(isVisible,(newValue,oldValue) => {
  if (newValue) {
    //先頭に持ってくる
    zIndex.value = getLargestZIndex();
    dialogResize();
  }
})
const checkFront = (elem) => {
  const rect = elem.getBoundingClientRect();
  const centerX = rect.left + rect.width / 2;
  const centerY = rect.top + rect.height / 2;
  // Viewportの中心付近にある最上層の要素を取得
  const topElement = document.elementFromPoint(centerX, centerY);
  // 対象要素と取得した要素が同じなら前面
  return elem === topElement?.closest('.modal-content');
}
const dialogResize = () => {
    nextTick(() => {
      //センタリングする
      topPosition.value = (((window.innerHeight - element.value.getBoundingClientRect().height) / window.innerHeight) * 100) / 2;
      //input要素で現在フォーカスが当たっている要素に再フォーカスを充てる
      let inputFocus = document.activeElement;
      if (inputFocus != null && (inputFocus.tagName == 'INPUT' || inputFocus.tagName == 'TEXTAREA')) {
        inputFocus.focus();
      }
    });
}
const resizeObserver = new ResizeObserver((entries) => {
  //前面に出ている場合のみリサイズ対応する
  if (checkFront(element.value)) {
    dialogResize();
  }
});
onMounted(() => {
  resizeObserver.observe(bodyElement.value);
})
onBeforeUnmount(() => {
  resizeObserver.unobserve(bodyElement.value);
})
</script>

<style scoped lang='sass'>
$mb: 767px
@mixin mobile 
  @media screen and (max-width:$mb)
    @content
.modal
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  background-color: rgba(0,0,0,0.5)
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
.modal-body
  padding:15px
  width:100%
  max-height:83vh
  -webkit-overflow-scrolling: touch
  overflow-scrolling: auto
  overflow-y: auto
.modal-content
  position: fixed
  top: 5%
  left: 2%
  right: 2%
  background-color: rgba(0,0,0,.5)
  color:#595757
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  background-color: white
  max-width: 96%
  min-width: 500px
  max-height: 90%
  width: auto
  height: auto
  border-radius: 10px
  border: 1px solid #eeebeb
  @include mobile
    min-width:350px
    max-width:100%
.modal-button-close
  display: flex
  align-items: center
  justify-content: center
  background-color: #EEEEEF
  text-align: center
  border-radius: 0 0 10px 10px
  height: 2.5em
  cursor: pointer
  width: 100%
.modal-button-left
  width:50%
  display: flex
  align-items: center
  justify-content: center
  background-color: #EEEEEF
  text-align: center
  border-radius: 0 0 0 10px
  height: 2.5em
  cursor: pointer
.modal-button-right
  width:50%
  display: flex
  align-items: center
  justify-content: center
  background-color: #F59E12
  color: white
  text-align: center
  border-radius: 0 0 10px 0
  height: 2.5em
  cursor: pointer
.loading-mask
  position: absolute
  z-index: 9998
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-color: rgba(0, 0, 0, 0.5)
  display: flex
  flex-flow: column
  transition: opacity 0.3s ease
.loading-content
  flex: 1
  display: flex
  align-items: center
  justify-content: center

</style>

<template>
<teleport to="body">
 <div class="modal" v-show="isVisible" :style="'z-index:' + zIndex + ';'"></div>
  <div ref="element" class="modal-content" v-show="isVisible" :style="'top:' + topPosition + '%;' + 'z-index:' + zIndex + ';'">
    <div v-if="isLoading" class="loading-mask">
      <div class="loading-content">
        <span style="color: white"><img src="../../public/images/loading.gif"></span>
      </div>
    </div>
    <div ref="bodyElement" class="modal-body">
      <slot ></slot>
    </div>
    <div v-if="(cancelButtonName.length > 0) && (submitButtonName.length == 0)" class="modal-button-close" @click="close">
      {{ cancelButtonName }}
    </div>
    <div v-else-if="(cancelButtonName.length > 0) && (submitButtonName.length > 0)" class="flex flex-row items-center w-full">
      <div class="modal-button-left" @click="close">
        {{ cancelButtonName }}
      </div>
      <div class="modal-button-right" @click="submit">
        {{ submitButtonName }}
      </div>
    </div>
  </div>
</teleport>
</template>

